import { useState } from "react";

function readPendingEmailVerification() {
  try {
    return JSON.parse(sessionStorage.getItem("blupay_email_verification")) || null;
  } catch {
    sessionStorage.removeItem("blupay_email_verification");
    return null;
  }
}

export function useSignUpFlow() {
  const [pendingChallenge] = useState(readPendingEmailVerification);
  const [step, setStep] = useState(pendingChallenge ? 4 : 1);

  const [formData, setFormData] = useState({
    userType: "", // buyer, seller, rider
    signupMethod: "", // sms, google, etc.
    phone: "",
    name: "",
    email: "",
    password: "",
    ...(pendingChallenge || {}),
  });

  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => Math.max(1, s - 1));

  // Helper to update specific fields without losing others
  const updateData = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  return {
    step,
    setStep, // Useful when jumping to a specific step
    nextStep,
    prevStep,
    formData,
    updateData
  };
}
